import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ProgramItem } from "core/http/service/internalEvents/types";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data?: ProgramItem[];
}

const initialState: InitialState = { status: ReduxStateType.INIT, data: [] };

const getProgramsSlice = createSlice({
  name: "getPrograms",
  initialState,
  reducers: {
    getProgramsStart: (state, action: PayloadAction<{ eventId: string }>) => {
      state.status = ReduxStateType.LOADING;
    },
    getProgramsSuccess: (
      state,
      action: PayloadAction<{
        data: ProgramItem[];
      }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = [...state.data, ...action.payload.data];
    },
    getProgramsFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = [];
    },
    resetPrograms: () => initialState,
  },
});

export const {
  getProgramsStart,
  getProgramsSuccess,
  getProgramsFailed,
  resetPrograms,
} = getProgramsSlice.actions;

export default getProgramsSlice.reducer;
